import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { AgentActionsList } from 'widgets/AgentActions'
import { SurveySwitch } from 'pages/surveys/ui/SurveySwitch/SurveySwitch'
import { CategoryActions } from 'pages/surveys/ui/SurveyView/ui/SuccessActions/ui/CategoryActions/CategoryActions'
import type { SuccessActionsStore } from './store/successActionsStore'
import { SUCCESS_ACTIONS_CONFIG, SUCCESS_ACTION_ITEMS } from './config'
import styles from './styles.module.scss'

type ISuccessActionsProps = {
  store: SuccessActionsStore
}

export const SuccessActions = observer(({ store }: ISuccessActionsProps) => {
  useEffect(() => {
    if (store.control.list.length > 0) store.resetSectionError()
  }, [store.control.list.length])

  return (
    <div className={styles.container}>
      <SurveySwitch
        label={'Different actions based on response'}
        active={store.isDifferentActions}
        onToggle={store.setIsDifferentActions}
      />
      {store.isDifferentActions ? (
        <div className={styles.categories}>
          <CategoryActions store={store.promoters} label='Promoters (9-10)' dotColor='green' />
          <CategoryActions store={store.passives} label='Passives (7-8)' dotColor='orange' />
          <CategoryActions store={store.detractors} label='Detractors (0-6)' dotColor='red' />
        </div>
      ) : (
        <AgentActionsList
          control={store.control}
          errors={store.errors}
          actionItems={SUCCESS_ACTION_ITEMS}
          actionsConfig={SUCCESS_ACTIONS_CONFIG}
          addButtonText='Add action (optional)'
        />
      )}
    </div>
  )
})
